<template>
  <avz-markers />
</template>

<script>
import Markers from '@/components/Markers'

export default {
  components: {
    'avz-markers': Markers
  }
}
</script>
